import patrickPhoto from "../img/Patrick_Self.png";

/**
 * Professional agents for Driscoll Co. Real Estate.
 * Edit this file to add or update agents. Add a photoUrl when you have one (e.g. in public/agents/ or import from src/img/).
 */
export const agents = [
  {
    id: "patrick-driscoll",
    name: "Patrick Driscoll",
    title: "REALTOR®, Broker",
    shortBio: "Two decades of experience in residential, commercial, and investment real estate. Proudly serving St. Louis and surrounding Missouri counties.",
    fullBio: "Patrick Driscoll is a dedicated REALTOR and Broker with Driscoll Co, LLC, proudly serving St. Louis and the surrounding Missouri counties. A long-time resident of Kirkwood, Missouri, Patrick has deep roots in the St. Louis metropolitan area and an intimate understanding of its diverse neighborhoods and real estate markets. With a career spanning nearly two decades, Patrick has been a licensed real estate agent since 2004. His extensive experience covers residential, commercial, and investment properties, as well as landlord and tenant representation. When not assisting clients, Patrick can often be found enjoying the many amenities Kirkwood and St. Louis have to offer.",
    email: "driscollcorp@gmail.com",
    phone: "(314) 922-3810",
    photoUrl: patrickPhoto,
    order: 0,
  },
  // Add more agents below. Example:
  // {
  //   id: "jane-smith",
  //   name: "Jane Smith",
  //   title: "REALTOR®",
  //   shortBio: "Specializing in residential sales in St. Louis County.",
  //   fullBio: "Full bio text here...",
  //   email: "jane@driscollcorp.com",
  //   phone: "(314) 555-0123",
  //   photoUrl: "/agents/jane.jpg",
  //   order: 1,
  // },
];
